<template>
    <div class="company-trade-root-container">
      <!-- 日历和金额统计 -->
      <div class="date-picker-container">
        <span style="margin-right: 10px"
          >{{ start_time_format }}至{{ end_time_format }}</span
        >
        <Button
          size="small"
          icon="md-calendar"
          type="text"
          @click="showTimeDrawer"
          >设置日期</Button
        >
        <div class="total-amount">
          总金额：
          <fee
            :amount="totalAmount"
            :primarySize="16"
            :secondarySize="14"
          />
        </div>
      </div>
  
      <div class="company-trade-row">
        <span style="font-size: 23px; font-weight: bold; color: #343733"
          >对平台的付款记录</span
        >
        <span
          style="
            font-size: 13px;
            font-weight: bold;
            color: #587bea;
            cursor: pointer;
          "
          @click="showTradeModal"
          >展示全部交易</span
        >
      </div>
      <div>
        <trade-item
          v-for="item in filteredTradeList"
          :key="item.trade_id"
          :data-source="item"
        />
      </div>
      <search-result-modal ref="searchResultModal" />
      <time-drawer ref="timeDrawer" @setTime="setTime" />
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import moment from "moment";
  import TradeItem from "../../Contact/Item/TradeItem";
  import SearchResultModal from "../../Home/Modal/SearchResultModal";
  import Fee from "../../../components/Fee"; // 引入 Fee 组件
  import TimeDrawer from "../../Home/Drawer/TimeDrawer"; // 引入 TimeDrawer 组件
  
  export default {
    components: {
      "trade-item": TradeItem,
      "search-result-modal": SearchResultModal,
      Fee, // 注册 Fee 组件
      "time-drawer": TimeDrawer, // 注册 TimeDrawer 组件
    },
    data() {
      return {
        company_id: 0,
        tradeList: [], // 原始交易列表
        filteredTradeList: [], // 过滤后的交易列表
        baseInfo: {},
        start_time: moment().startOf('month').toISOString(), // 默认开始时间
        end_time: moment().endOf('month').toISOString(), // 默认结束时间
        totalAmount: 0, // 总金额
      };
    },
    computed: {
      // 格式化日期显示
      start_time_format() {
        return moment(this.start_time).format("YYYY年MM月DD日");
      },
      end_time_format() {
        return moment(this.end_time).format("YYYY年MM月DD日");
      },
    },
    mounted() {
      this.company_id = this.$route.params.id;
      this.getCompanyBasic();
      this.getTradeList();
    },
    methods: {
      ...mapActions({
        companyGetTradeListAction: "companyGetTradeList",
        companyGetCompanyBasicAction: "companyGetCompanyBasic",
      }),
      getCompanyBasic() {
        this.companyGetCompanyBasicAction({
          company_id: this.company_id,
        })
          .then((res) => {
            this.baseInfo = res;
          })
          .catch((error) => {
            this.$Message.error(error);
          });
      },
      getTradeList() {
        this.companyGetTradeListAction({
          company_id: this.company_id,
        })
          .then((res) => {
            for (let item of res) {
              item.create_time = moment(item.create_time).format(
                "YYYY/MM/DD HH:mm"
              );
            }
            this.tradeList = res;
            this.filterTradeList(); // 初始化过滤
          })
          .catch((error) => {
            this.$Message.error(error);
          });
      },
      showTradeModal() {
        this.$refs.searchResultModal.open(
          {
            type: 2,
            search_content: this.company_id,
            search_content_format: this.baseInfo.name,
            start_time: this.start_time,
            end_time: this.end_time,
          },
          0
        );
      },
      // 显示日期选择抽屉
      showTimeDrawer() {
        this.$refs.timeDrawer.open(this.start_time, this.end_time);
      },
      // 设置日期范围
      setTime(obj) {
        this.start_time = obj.start_time;
        this.end_time = obj.end_time;
        this.filterTradeList(); // 重新过滤数据
      },
      // 过滤交易列表并计算总金额
      filterTradeList() {
        const startDate = moment(this.start_time);
        const endDate = moment(this.end_time);
  
        this.filteredTradeList = this.tradeList.filter((item) => {
          const createTime = moment(item.create_time);
          return createTime.isBetween(startDate, endDate, null, "[]");
        });
  
        // 计算总金额
        this.totalAmount = this.filteredTradeList.reduce((sum, item) => {
            const salaryAmount = parseFloat(item.salary_amount) || 0;
            const serviceAmount = parseFloat(item.service_amount) || 0;
            return sum + salaryAmount + serviceAmount;
        }, 0);
      },
    },
  };
  </script>
  
  <style scoped>
  .company-trade-root-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .company-trade-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .date-picker-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }
  .total-amount {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  white-space: nowrap; /* 防止折行 */
  display: inline-flex; /* 确保内容在同一行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 4px; /* 总金额和 fee 组件之间的间距 */
}
.fee-component {
  display: inline-block; /* 确保 fee 组件不折行 */
}
  </style>